import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { Timeffort } from '@/app.context/workspace/persons/sunrises/effort.rmodel';
import { IResolution, Status } from '@/logic/workspaces/tickets/_def'
import { timeffortCss_Squashed } from '@/controllers/workspaces/persons/effort.controller'
import { computed } from 'vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'TimeffortIconComponent_Timeline',
  props: {
    item: {},
    resolution: {}
  },
  setup(__props: any) {

const props = __props

const resolution_final =  computed(() => {
  
    if (props.resolution == null) return null

    if (props.resolution != undefined){

        return props.resolution
    }
    else return props.item.isTicket() ? props.item.resolution : null
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("i", {
    class: _normalizeClass(_unref(timeffortCss_Squashed)(_ctx.item, resolution_final.value))
  }, null, 2))
}
}

})